<template>
  <div class="card modal-card width-535">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('detailContrat.popupSelectionIntervenant.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="columns is-vcentered">
          <div class="column is-narrow label mgt-5px">
            {{ $t('detailContrat.popupSelectionIntervenant.selectIntervenant') }}
          </div>
          <div class="column is-5">
            <b-select v-model="tiersId" expanded>
              <option v-for="intervenant in intervenants"
                      :key="intervenant.tiersId"
                      :value="intervenant.tiersId">
                {{ intervenant.tiers.nomCommercial }}
              </option>
            </b-select>
          </div>
        </div>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="$emit('intervenantSelected', tiersId)">
                {{ $t('general.button.next')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'p_selectionFacturationIntervenant',
  props: {
    intervenants: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tiersId: null,
    };
  },
  mounted() {
    this.tiersId = this.intervenants[0].tiersId;
  },
};
</script>

<style scoped>

</style>
